const debounce = (fn, delay) => {
  let timer;
  return (...args) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
};

export const enhanceResizeObserver = () => {
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class EnhancedResizeObserver extends (
    OriginalResizeObserver
  ) {
    constructor(callback) {
      super(debounce(callback, 200));
    }
  };
};
